import React from 'react';
import { Style } from 'radium';

import { appConfig } from '../config/customization';
import '../fonts/Poppins.css';
import '../fonts/Swiss721.css';

const styles = {
  'body, html, #root, [data-reactroot]': {
    padding: 0,
    margin: 0,
    fontFamily: appConfig.fontFamily,
    height: '100%'
  },
  button: {
    fontFamily: appConfig.fontFamily
  },
  'input::-ms-reveal': {
    display: 'none'
  }
};

export default <Style rules={styles} />;
